<template>
  <div>
    <div class="container">
      <div class="title-introduction">
        <div class="title-responsive">
          <span class="title-main">{{ $t("introduction.welcome") }}</span>
          <span class="title-second">{{ $t("introduction.pagename") }}</span>
        </div>
        <!-- Logo -->
        <!-- <div class="centered" style="top: 70px;">
          <div v-if="!forConasi">
            <img
              class="logo-responsive"
              src="../../assets/e_voucher_logo_border_white.svg"
            />
          </div>
          <div v-else>
            <img
              class="logo-responsive"
              src="../../assets/e_voucher_logo_white.png"
            />
          </div>
        </div> -->
        <!-- <div style="display: flex;"> -->
      </div>
      <div class="mt-3">
        <!-- <div class="mr-2">
          <b-button
            class="button-primary"
            v-if="$i18n.locale == 'vi'"
            size="lg"
            @click="onChangeLanguage('en')"
          >
            English
          </b-button>
          <b-button
            class="button-primary"
            v-else
            size="lg"
            @click="onChangeLanguage('vi')"
          >
            Tiếng việt
          </b-button>
        </div> -->
        <div>
          <b-button class="button-primary" @click="onStart">
            {{ $t("common.start") }}
          </b-button>
        </div>
      </div>
    </div>
    <!-- <div style="position: absolute; bottom: 0; width: 100%; padding: 35px; padding-bottom: 15px;">
        <div style="float: right;">
          <a :href="`tel:${hotline}`" style="align-self: flex-end;" class="text-white mb-4 hotline-font" v-if="hotline"><b-icon-headset style="color: #fff;"></b-icon-headset> Hotline: {{ hotline }}</a>
        </div>
      </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import stringUtils from 'Utils/stringUtils'
import { FOR_CONASI_TARGET } from 'Utils/constants'
export default {
  data: () => ({
    forConasi: FOR_CONASI_TARGET,
    objectSettingKey: stringUtils.ObjectSettingKey,
    hotline: null
  }),
  computed: {
    ...mapGetters(['OBJECT_SETTING_DATA'])
  },
  watch: {
    OBJECT_SETTING_DATA () {
      let data = this.OBJECT_SETTING_DATA
      let hotlineSettingData = data.filter(element => {
        return element.key === this.objectSettingKey.COMPANY_HOTLINE
      })
      if (hotlineSettingData.length > 0) {
        this.hotline = hotlineSettingData[0].value
      }
    }
  },
  created () {
    if (!this.forConasi) {
      this.$router.push({
        path: '/look-up-voucher'
      })
    }
    let filter = {
      params: {
        key: this.objectSettingKey.COMPANY_HOTLINE
      }
    }
    this.GET_OBJECT_SETTING(filter)
  },
  methods: {
    /**
     * Change language
     */
    onChangeLanguage: function(locale) {
      this.CHANGE_LOCALE(locale);
    },
    /**
     * On start
     */
    onStart: function() {
      this.$router.push({
        path: "look-up-voucher",
      });
    },
    ...mapActions(["CHANGE_LOCALE", "GET_OBJECT_SETTING"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";

.container {
  // background-color: $bg-primary;
  margin-top: 30vh;
}

.button-primary {
  background-color: $btn-background;
  color: $text-primary;
  border-radius: 1em;
}
.title-introduction {
  display: flex;
  width: 100%;
}
.title-main,
.title-second {
  white-space: nowrap;
  display: block;
  font-size: 3em;
  letter-spacing: 7px;
  color: #ff6d6d;
  font-weight: bold;
  text-shadow: 0 0 0.6rem #8d6d6d, 0 0 1.5rem #0c2e0d94, 
  -0.2rem 0.1rem 1rem #03140494, 0.2rem 0.1rem 1rem #00000094, 
  0 -0.5rem 2rem #43a047, 0 0.5rem 3rem #0b120b;
}
.title-main {
  text-transform: uppercase;
}
.title-second {
  color: white;
  font-size: 1.5em;
  font-style: italic;
}

.hotline-font {
  font-size: 18px;
}

.btn-language {
  bottom: 35px; 
  left: 35px;
}

.txt-hotline {
  bottom: 35px; 
  right: 35px;
}

/* 
  ##Device = Desktops
  ##Screen = 1281px to higher resolution desktops
*/

// @media (min-width: 1281px) {
//   .logo-responsive {
//     width: 30%;
//   }
//   .title-responsive {
//     width: 50%;
//   }
// }

/* 
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/

// @media (min-width: 1025px) and (max-width: 1280px) {
//   .logo-responsive {
//     width: 40%;
//   }
//   .title-responsive {
//     width: 50%;
//   }
// }

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

// @media (min-width: 768px) and (max-width: 1024px) {
//   .logo-responsive {
//     width: 40%;
//   }
//   .centered {
//     left: 50%;
//     line-height: 0.7;
//   }
//   .title-introduction {
//     font-size: 22px;
//   }
//   .btn-group-lg>.btn, .btn-lg {
//     font-size: 0.75rem;
//   }
//   .title-responsive {
//     width: 50%;
//   }
// }

/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/

// @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
//   .logo-responsive {
//     width: 40%;
//   }
//   .centered {
//     left: 50%;
//     line-height: 0.7;
//   }
//   .title-introduction {
//     font-size: 22px;
//   }
//   .btn-group-lg>.btn, .btn-lg {
//     font-size: 0.75rem;
//   }
//   .title-responsive {
//     width: 50%;
//   }
// }

/* 
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/

// @media (min-width: 481px) and (max-width: 767px) {
//   .logo-responsive {
//     width: 60%;
//   }
//   .centered {
//     left: 0%;
//     line-height: 0.7;
//   }
//   .title-introduction {
//     font-size: 18px;
//   }
//   .btn-group-lg>.btn, .btn-lg {
//     font-size: 0.75rem;
//   }
//   .title-responsive {
//     width: 100%;
//   }
// }

/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 540px) and (max-width: 720px) {
  .title-main {
    font-size: 2em;
    letter-spacing: 3px;
  }
  .title-second {
    font-size: 1.5em;
    letter-spacing: 3px;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  .title-main {
    font-size: 1.5em;
    letter-spacing: 3px;
  }
  .title-second {
    font-size: 0.8em;
    letter-spacing: 3px;
  }
}
</style>
